import type { KeyboardEvent, ReactNode } from 'react';

export function SummaryCard({ label, value }: { label: string; value: string }) {
  return (
    <div className="gda-analytics-card">
      <span className="gda-analytics-card__value">{value}</span>
      <span className="gda-analytics-card__label">{label}</span>
    </div>
  );
}

export function SearchStyleTabs({
  tabs,
  activeTab,
  onTabChange,
}: {
  tabs: Array<{ label: string; value: string }>;
  activeTab: string;
  onTabChange: (value: string) => void;
}) {
  const handleKeyDown = (event: KeyboardEvent<HTMLLIElement>, index: number) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (index + direction + tabs.length) % tabs.length;
    onTabChange(tabs[nextIndex].value);
  };

  return (
    <div className="react-tabs gda-analytics-panel__tabs">
      <ul className="react-tabs__tab-list col-auto" role="tablist">
        {tabs.map((tab, index) => {
          const isSelected = activeTab === tab.value;
          return (
            <li
              key={tab.value}
              role="tab"
              aria-selected={isSelected}
              tabIndex={isSelected ? 0 : -1}
              className={`react-tabs__tab-analytics bg-white mb-0 my-2 my-lg-0 m-1 ${isSelected ? 'react-tabs__tab--selected' : ''}`}
              onClick={() => onTabChange(tab.value)}
              onKeyDown={event => handleKeyDown(event, index)}
            >
              {tab.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export function ChartPanel({
  title,
  tabs,
  activeTab,
  onTabChange,
  children,
  className = '',
}: {
  title: string;
  tabs?: Array<{ label: string; value: string }>;
  activeTab?: string;
  onTabChange?: (value: string) => void;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={`gda-analytics-panel ${className}`.trim()}>
      <div className="gda-analytics-panel__header">
        <h4 className="gda-analytics-panel__title">{title}</h4>
        {tabs?.length && activeTab && onTabChange ? (
          <SearchStyleTabs tabs={tabs} activeTab={activeTab} onTabChange={onTabChange} />
        ) : null}
      </div>
      <div className="gda-analytics-panel__body">{children}</div>
    </section>
  );
}
